import { createContext } from 'react';
import useDropdownState from '../hooks/use-dropdown-state';

const DropdownContext = createContext<ReturnType<typeof useDropdownState>>(null!);

export default DropdownContext;
